
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, DollarSign, SearchCode } from "lucide-react";
import { Button } from "@/components/ui/button";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const showForSaleButton = false;

  const mainNavItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Solutions", path: "/solutions" },
    { name: "Deepseek", path: "/deepseek" },
    { name: "What is DeepSeek AI", path: "/what-is-deepseek-ai" },
    { name: "Blog", path: "/blog" },
    { name: "Contact", path: "/contact" },
  ];

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdnjs.buymeacoffee.com/1.0.0/button.prod.min.js";
    script.setAttribute("data-name", "bmc-button");
    script.setAttribute("data-slug", "deepseekai");
    script.setAttribute("data-color", "#40DCA5");
    script.setAttribute("data-emoji", "🚀");
    script.setAttribute("data-font", "Lato");
    script.setAttribute("data-text", "Fuel the Mission");
    script.setAttribute("data-outline-color", "#000000");
    script.setAttribute("data-font-color", "#ffffff");
    script.setAttribute("data-coffee-color", "#FFDD00");
    document.body.appendChild(script);
  }, []);

  return (
    <nav className="fixed w-full bg-white z-40 border-b shadow-sm mt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 relative">
          <div className="flex-shrink-0">
            <Link 
              to="/" 
              className="flex items-center space-x-2 hover:opacity-90 transition-opacity"
            >
              <SearchCode 
                className="h-8 w-8 text-[#0066FF] animate-[wave_2s_ease-in-out_infinite]" 
                strokeWidth={1.5}
              />
              <span className="text-xl sm:text-2xl font-bold text-[#0066FF]">
                DeepSeek AI
              </span>
            </Link>
          </div>

          {showForSaleButton && (
            <a
              href="mailto:info@deepseek.ai"
              className="absolute left-1/2 -translate-x-1/2 top-full mt-2 md:mt-0 md:static md:transform-none inline-flex items-center justify-center px-3 py-1 text-xs font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 transition-all border border-gray-200 shadow-sm animate-rainbow"
            >
              <DollarSign className="mr-1 h-3 w-3" />
              DeepSeek.ai is For Sale!
            </a>
          )}

          <div className="hidden md:flex items-center space-x-4">
            {mainNavItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-[#0066FF] hover:bg-gray-50 rounded-md transition-colors"
              >
                {item.name}
              </Link>
            ))}
            
            <div className="bmc-button"></div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#0066FF] hover:bg-gray-50 transition-colors"
              aria-label="Toggle menu"
            >
              {isOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {isOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b shadow-lg animate-fadeIn">
            <div className="px-4 py-2 space-y-1">
              {mainNavItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="block px-4 py-2 text-base font-medium text-gray-700 hover:text-[#0066FF] hover:bg-gray-50 rounded-md transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              
              <div className="bmc-button px-4 py-2"></div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
